import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { FC } from "react";
import styled from "styled-components";
import { theme } from "../../Customization/Theme";
import { RootState, useAppSelector } from "../../Store";
import { useTopBarNotification } from "./useTopBarNotification";

const NotificationBar: FC = () => {
  const { hideTopBarNotification } = useTopBarNotification();
  const { message, show, isClosedBefore } = useAppSelector(
    (state: RootState) => state.notificationBar
  );

  if (!show || !message) return null;

  if (isClosedBefore) return null;

  return (
    <StyledContainer show={show} className="customNotificationBarStyle">
      {/* <div className="textContainer">{message}</div>
      <IconButton
        className="buttonContainer"
        onClick={() => hideTopBarNotification()}
      >
        <CloseIcon />
      </IconButton> */}
      {message}
    </StyledContainer>
  );
};

export default NotificationBar;

// Highlighted change in the StyledContainer
const StyledContainer = styled.div<{ show: boolean }>`
  && {
    background-color: ${theme.palette.default.error};
    width: 100%;
    max-height: 64px;
    height: ${({ show }: any) => (show ? "auto" : "0")};
    opacity: ${({ show }: any) => (show ? 1 : 0)};
    overflow: hidden;
    transition: all 0.3s ease-in-out;
    /* display: flex;
    padding: 0.25rem 1rem;
    justify-content: center;
    align-items: center;
    gap: 1rem; */

    /* .textContainer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      font-size: 0.9rem;
      color: ${theme.palette.default.white};
    }

    .closeButton {
      margin-left: auto;
      padding: 8px;
      svg {
        font-size: 1.2rem;
        color: ${theme.palette.default.white};
      }
    } */
  }
`;

interface NotificationBarContainerProps {
  $variant: "success" | "error" | "info";
}

const getBackgroundColor = (
  variant: NotificationBarContainerProps["$variant"]
) => {
  switch (variant) {
    case "success":
      return theme.palette.default.success;
    case "error":
      return theme.palette.default.error;
    case "info":
      return theme.palette.default.lightYellow;
    default:
      return theme.palette.default.error; // Fallback to error if no match
  }
};

const getTextColor = (variant: NotificationBarContainerProps['$variant']) => {
  switch (variant) {
    case 'info':
      return theme.palette.default.text;
    default:
      return theme.palette.default.white;
  }
};

export const NotificationBarContainer = styled.div<NotificationBarContainerProps>`
  && {
    background-color: ${({ $variant }: any) => getBackgroundColor($variant)};
    width: 100%;
    height: 100%;
    min-height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    padding: 0.25rem 1rem;
    position: relative;
    .text {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      font-size: 0.9rem;
      color: ${({ $variant }:any) => getTextColor($variant)};
    }

    .closeButton {
      position: absolute;
      right: 8px;
      padding: 6px;
      svg {
        font-size: 1.1rem;
      }
    }
  }
`;
